import { Container, Heading } from '@wienenergiegithub/ui-next';
import styles from './Result.module.scss';
import { Efficiency } from '../Efficiency';
import { Furnace } from '../Furnace';
import { HeatFacts } from '../HeatFacts';
import { HeatPotential } from '../HeatPotential';
import React from 'react';
import PropTypes from 'prop-types';

const Result = ({ results, heatPotential }) => (
  <Container size="lg">
    <Heading className={styles.heading} size="h2">
      Ihr Ergebnis
    </Heading>
    <div className={styles.container}>
      <Efficiency
        className={styles.effiencyContainer}
        finalPoints={results?.finalPoints}
        tacho={results?.tacho}
      />
      {!!results?.text && (
        <Furnace
          className={styles.furnaceContainer}
          image={results?.image}
          link={results?.link}
          text={results?.text}
        />
      )}

      <HeatFacts className={styles.factsContainer} />
    </div>
    {!!heatPotential && <HeatPotential heatPotential={heatPotential} />}
  </Container>
);

Result.propTypes = {
  heatPotential: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      id: PropTypes.number,
      question: PropTypes.string,
      tipps: PropTypes.arrayOf(
        PropTypes.shape({
          icon: PropTypes.string,
          id: PropTypes.number,
          link: PropTypes.string,
          text: PropTypes.string,
          title: PropTypes.string,
        }),
      ),
    }),
  ),
  results: PropTypes.shape({
    finalPoints: PropTypes.number,
    image: PropTypes.string,
    tacho: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.string,
  }),
};

export { Result };
